
import ApiService from "@/common/ApiService";
import urlConfig from "@/../public/urlConfig.json";
import Vue from "vue";
const apiService = new ApiService(Vue.prototype.$config.profileBaseAddress);

export default {

    mutations: {

    },

    getters: {

    },

    actions: {
        async getHotelListCrs(context, queryString) {
            try {
             
                const response = await apiService.Get("HotelRoom/GetHotelList?" + queryString);

                return (response.data);
            } catch (err) {
                console.log(err);
            }
        },
   
      async AvailableRoomsCrs(context, queryString) {
            try {
             debugger
                const response = await apiService.Post("HotelRoom/AvailableRooms?" , queryString);
                return (response.data);
            } catch (err) {
                console.log(err);
            }
        },
    }
}